import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import ReRenderOnMount from 'components/consumer/ReRenderOnMount';
import scrollToTop from 'commons/scrollToTop';
import scrollIntoViewUtil from 'commons/scrollIntoViewUtil';
import useScreen from 'hooks/useScreen';
import DesktopOnly from 'components/consumer/DesktopOnly';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import usePDPClearanceData from 'data-hooks/useClearanceData/usePDPClearanceData';
import useIsBrowser from 'hooks/useIsBrowser';
import PDPNotification from '../PDPNotification';
import PDPLeadTimeUI from '../PDPNameSection/PDPLeadTimeUI';
import PDPAlertBar from '../PDPAlertBar';
import usePdpSetShowStickyButtons from '../state/context/usePdpSetShowStickyButtons';
import usePdpShowStickyButtons from '../state/context/usePdpShowStickyButtons';
import usePdpStickyPriceRow from '../state/context/usePdpStickyPriceRow';
import useShowStickyButtons from './hooks/useShowStickyButtons';
import PDPAvailableInSizesListItem from '../PDPAvailableInSizes/PDPAvailableInSizesRow/PDPAvailableInSizesListItem';
import PDPAddToBagButton from './PDPAddToBagButton';
const PDPAddToBagSectionUI = t0 => {
  const $ = _c(85);
  const {
    addingToCart,
    addToCartError,
    allowUserToCustomize,
    buildYourOwnDetails: t1,
    campaign,
    cartDisabled,
    isDiscontinued: t2,
    isModularBundleProduct: t3,
    isOutOfStock: t4,
    loading,
    mode: t5,
    onAddToCart,
    selectedMaterial,
    showClearanceAlert: t6,
    stickyDesktopButtonOnly: t7,
    forceStickyVisible: t8,
    isLayoutRevamp: t9
  } = t0;
  let t10;
  if ($[0] !== t1) {
    t10 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t10;
  } else {
    t10 = $[1];
  }
  const buildYourOwnDetails = t10;
  const isDiscontinued = t2 === undefined ? false : t2;
  const isModularBundleProduct = t3 === undefined ? false : t3;
  const isOutOfStock = t4 === undefined ? false : t4;
  const mode = t5 === undefined ? "pdp" : t5;
  const showClearanceAlert = t6 === undefined ? false : t6;
  const stickyDesktopButtonOnly = t7 === undefined ? false : t7;
  const forceStickyVisible = t8 === undefined ? false : t8;
  const isLayoutRevamp = t9 === undefined ? false : t9;
  const {
    isMobileOrTablet
  } = useScreen();
  const [addToBagSection, setAddToBagSection] = useState(null);
  const [overrideCustomize, setOverrideCustomize] = useState(false);
  const isBrowser = useIsBrowser();
  const [showClearanceMobileNotification, setShowClearanceMobileNotification] = useState(false);
  const {
    data: pdpClearanceData
  } = usePDPClearanceData();
  const isFlashSale = pdpClearanceData?.optionsClearanceData?.[selectedMaterial?.sku]?.flashSale || false;
  pdpClearanceData?.optionsClearanceData;
  let t11;
  if ($[2] !== pdpClearanceData?.optionsClearanceData) {
    t11 = Object.keys(pdpClearanceData?.optionsClearanceData || {});
    $[2] = pdpClearanceData?.optionsClearanceData;
    $[3] = t11;
  } else {
    t11 = $[3];
  }
  const clearanceOptions = t11;
  let t12;
  let t13;
  if ($[4] !== clearanceOptions || $[5] !== selectedMaterial) {
    t12 = () => {
      if (clearanceOptions.length > 0 && selectedMaterial?.sku) {
        const isSelectedOptionOnClearance = clearanceOptions.includes(selectedMaterial.sku) || false;
        setShowClearanceMobileNotification(isSelectedOptionOnClearance);
      }
    };
    t13 = [clearanceOptions, selectedMaterial];
    $[4] = clearanceOptions;
    $[5] = selectedMaterial;
    $[6] = t12;
    $[7] = t13;
  } else {
    t12 = $[6];
    t13 = $[7];
  }
  useEffect(t12, t13);
  const stickyPriceRow = usePdpStickyPriceRow();
  const measuredShowStickyButtons = useShowStickyButtons(stickyDesktopButtonOnly ? null : addToBagSection, stickyPriceRow);
  const publishShowStickyButtons = usePdpSetShowStickyButtons();
  const publishedShowStickyButtons = usePdpShowStickyButtons();
  let t14;
  let t15;
  if ($[8] !== measuredShowStickyButtons || $[9] !== publishShowStickyButtons || $[10] !== stickyDesktopButtonOnly) {
    t14 = () => {
      if (stickyDesktopButtonOnly) {
        return;
      }
      publishShowStickyButtons(measuredShowStickyButtons);
    };
    t15 = [stickyDesktopButtonOnly, publishShowStickyButtons, measuredShowStickyButtons];
    $[8] = measuredShowStickyButtons;
    $[9] = publishShowStickyButtons;
    $[10] = stickyDesktopButtonOnly;
    $[11] = t14;
    $[12] = t15;
  } else {
    t14 = $[11];
    t15 = $[12];
  }
  useEffect(t14, t15);
  const showStickyButtons = forceStickyVisible || (stickyDesktopButtonOnly ? publishedShowStickyButtons : measuredShowStickyButtons);
  let t16;
  if ($[13] !== isMobileOrTablet) {
    t16 = () => {
      if (isMobileOrTablet) {
        scrollIntoViewUtil("[data-xc=\"MaterialThumbnailGroup\"]");
      } else {
        scrollToTop();
      }
    };
    $[13] = isMobileOrTablet;
    $[14] = t16;
  } else {
    t16 = $[14];
  }
  const onCustomizeClick = t16;
  let t17;
  if ($[15] !== allowUserToCustomize || $[16] !== onAddToCart || $[17] !== onCustomizeClick || $[18] !== overrideCustomize) {
    t17 = (event, isStickyButton) => {
      if (isStickyButton && allowUserToCustomize && !overrideCustomize) {
        onCustomizeClick();
      } else {
        onAddToCart();
      }
      setOverrideCustomize(true);
    };
    $[15] = allowUserToCustomize;
    $[16] = onAddToCart;
    $[17] = onCustomizeClick;
    $[18] = overrideCustomize;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  const onClick = t17;
  if (stickyDesktopButtonOnly) {
    const t18 = !showStickyButtons;
    let t19;
    if ($[20] !== showStickyButtons || $[21] !== t18) {
      t19 = classNames("transition-opacity ease-in max-[1023px]:hidden whitespace-nowrap", {
        invisible: t18,
        visible: showStickyButtons
      });
      $[20] = showStickyButtons;
      $[21] = t18;
      $[22] = t19;
    } else {
      t19 = $[22];
    }
    const t20 = allowUserToCustomize && !overrideCustomize;
    let t21;
    if ($[23] !== addToCartError || $[24] !== addingToCart || $[25] !== campaign || $[26] !== cartDisabled || $[27] !== isLayoutRevamp || $[28] !== loading || $[29] !== onClick || $[30] !== t20) {
      t21 = <PDPAddToBagButton addingToCart={addingToCart} addToCartError={addToCartError} campaign={campaign} cartDisabled={cartDisabled} loading={loading} isCustomizeButton={t20} isLayoutRevamp={isLayoutRevamp} isStickyButton={true} onClick={onClick} />;
      $[23] = addToCartError;
      $[24] = addingToCart;
      $[25] = campaign;
      $[26] = cartDisabled;
      $[27] = isLayoutRevamp;
      $[28] = loading;
      $[29] = onClick;
      $[30] = t20;
      $[31] = t21;
    } else {
      t21 = $[31];
    }
    let t22;
    if ($[32] !== t19 || $[33] !== t21) {
      t22 = <DesktopOnly><div data-xc="PDPAddToBagStickyDesktopContainer" className={t19}>{t21}</div></DesktopOnly>;
      $[32] = t19;
      $[33] = t21;
      $[34] = t22;
    } else {
      t22 = $[34];
    }
    return t22;
  }
  if (isDiscontinued) {
    let t18;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <><div /><div /></>;
      $[35] = t18;
    } else {
      t18 = $[35];
    }
    return t18;
  }
  const t18 = mode === "quickview";
  let t19;
  if ($[36] !== t18) {
    t19 = classNames("PDPAddToBagSectionUI mt-8", {
      "mt-0 md:mt-4": t18
    });
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== addToCartError || $[39] !== addingToCart || $[40] !== campaign || $[41] !== cartDisabled || $[42] !== isLayoutRevamp || $[43] !== loading || $[44] !== onClick) {
    t20 = <ReRenderOnMount><PDPAddToBagButton addingToCart={addingToCart} addToCartError={addToCartError} campaign={campaign} cartDisabled={cartDisabled} isLayoutRevamp={isLayoutRevamp} loading={loading} onClick={onClick} /></ReRenderOnMount>;
    $[38] = addToCartError;
    $[39] = addingToCart;
    $[40] = campaign;
    $[41] = cartDisabled;
    $[42] = isLayoutRevamp;
    $[43] = loading;
    $[44] = onClick;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== isBrowser || $[47] !== isLayoutRevamp || $[48] !== isOutOfStock || $[49] !== loading || $[50] !== mode || $[51] !== showClearanceAlert) {
    t21 = !isOutOfStock ? <div>{!isBrowser || loading ? <Placeholder type="rect" loading={true} style={{
        height: "12px",
        marginTop: "20px"
      }} /> : <div data-xc="PDPAddToBagLeadTime" className="flex items-center justify-center flex-wrap"><PDPLeadTimeUI mode={mode} isLayoutRevamp={isLayoutRevamp} /></div>}{!loading && showClearanceAlert && <DesktopOnly><div data-xc="PDPAddToBagClearanceAlert" className="max-[1023px]:hidden"><PDPAlertBar type="info">{"Clearance item: ineligible for returns except for items arriving damaged & documented by carrier. Ineligible for warranty claims unless reports of defects are submitted within 14 days of delivery, cosmetic damage isn't covered."}</PDPAlertBar></div></DesktopOnly>}</div> : <div />;
    $[46] = isBrowser;
    $[47] = isLayoutRevamp;
    $[48] = isOutOfStock;
    $[49] = loading;
    $[50] = mode;
    $[51] = showClearanceAlert;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== buildYourOwnDetails || $[54] !== isModularBundleProduct || $[55] !== mode) {
    t22 = mode === "pdp" && isModularBundleProduct && buildYourOwnDetails?.name ? <PDPAvailableInSizesListItem dimensions={buildYourOwnDetails.dimensions || ""} loading={false} id="byo" image="" isActive={false} name={`Build your own ${buildYourOwnDetails.name}`} byoCollectionName={buildYourOwnDetails.name} price="" urlKey={buildYourOwnDetails.urlKey} isBYO={true} /> : <div />;
    $[53] = buildYourOwnDetails;
    $[54] = isModularBundleProduct;
    $[55] = mode;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== isFlashSale || $[58] !== isMobileOrTablet || $[59] !== showClearanceMobileNotification) {
    t23 = !isFlashSale && isMobileOrTablet && showClearanceMobileNotification && <PDPNotification subheading={"This final sale product is eligible for cancellation within 24 hours\n            of order placement. Ineligible for returns except for items arriving\n            damaged & documented by carrier. Ineligible for warranty claims unless\n            reports of defects are submitted within 14 days of delivery, cosmetic\n            damage isn't covered."} onClose={() => setShowClearanceMobileNotification(false)} showCloseButton={false} baseStyleExtension="mb-4" />;
    $[57] = isFlashSale;
    $[58] = isMobileOrTablet;
    $[59] = showClearanceMobileNotification;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  let t24;
  if ($[61] !== t19 || $[62] !== t20 || $[63] !== t21 || $[64] !== t22 || $[65] !== t23) {
    t24 = <div className={t19} ref={setAddToBagSection} data-xc="PDPAddToBagSectionUI">{t20}{t21}{t22}{t23}</div>;
    $[61] = t19;
    $[62] = t20;
    $[63] = t21;
    $[64] = t22;
    $[65] = t23;
    $[66] = t24;
  } else {
    t24 = $[66];
  }
  const t25 = !showStickyButtons;
  let t26;
  if ($[67] !== showStickyButtons || $[68] !== t25) {
    t26 = classNames("bg-white left-0 right-0 bottom-0 p-4 fixed z-20 lg:hidden", {
      "opacity-0 hidden": t25,
      "opacity-100 block": showStickyButtons
    });
    $[67] = showStickyButtons;
    $[68] = t25;
    $[69] = t26;
  } else {
    t26 = $[69];
  }
  const t27 = allowUserToCustomize && !overrideCustomize;
  let t28;
  if ($[70] !== addToCartError || $[71] !== addingToCart || $[72] !== campaign || $[73] !== cartDisabled || $[74] !== isLayoutRevamp || $[75] !== loading || $[76] !== onClick || $[77] !== t27) {
    t28 = <PDPAddToBagButton addingToCart={addingToCart} addToCartError={addToCartError} campaign={campaign} cartDisabled={cartDisabled} loading={loading} isCustomizeButton={t27} isLayoutRevamp={isLayoutRevamp} isStickyButton={true} onClick={onClick} />;
    $[70] = addToCartError;
    $[71] = addingToCart;
    $[72] = campaign;
    $[73] = cartDisabled;
    $[74] = isLayoutRevamp;
    $[75] = loading;
    $[76] = onClick;
    $[77] = t27;
    $[78] = t28;
  } else {
    t28 = $[78];
  }
  let t29;
  if ($[79] !== t26 || $[80] !== t28) {
    t29 = <MobileAndTabletOnly><FixedWidthContainer data-xc="PDPAddToBagStickyMobileContainer" className={t26}>{t28}</FixedWidthContainer></MobileAndTabletOnly>;
    $[79] = t26;
    $[80] = t28;
    $[81] = t29;
  } else {
    t29 = $[81];
  }
  let t30;
  if ($[82] !== t24 || $[83] !== t29) {
    t30 = <>{t24}{t29}</>;
    $[82] = t24;
    $[83] = t29;
    $[84] = t30;
  } else {
    t30 = $[84];
  }
  return t30;
};
PDPAddToBagSectionUI.propTypes = {
  addingToCart: PropTypes.bool,
  addToCartError: PropTypes.string,
  allowUserToCustomize: PropTypes.bool,
  buildYourOwnDetails: PropTypes.shape({
    dimensions: PropTypes.string,
    name: PropTypes.string,
    urlKey: PropTypes.string
  }),
  cartDisabled: PropTypes.bool,
  showClearanceAlert: PropTypes.bool,
  isDiscontinued: PropTypes.bool,
  isModularBundleProduct: PropTypes.bool,
  isOutOfStock: PropTypes.bool,
  loading: PropTypes.bool,
  mode: PropTypes.oneOf(['quickview', 'pdp']),
  onAddToCart: PropTypes.func,
  stickyDesktopButtonOnly: PropTypes.bool,
  forceStickyVisible: PropTypes.bool,
  isLayoutRevamp: PropTypes.bool,
  campaign: PropTypes.string,
  selectedMaterial: PropTypes.shape({
    exclude_from_sale: PropTypes.bool,
    additionalCost: PropTypes.number,
    description: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string,
    materialId: PropTypes.number,
    origAddlCost: PropTypes.number,
    upholsteryOptionId: PropTypes.number,
    value: PropTypes.string,
    sku: PropTypes.string
  })
};
export default PDPAddToBagSectionUI;